import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'


export function ToggleDark(){
    const [isEnabled, setIsEnabled] = useState(false);

	useEffect(() => {
        updateTheme(isEnabled);
        }, [isEnabled]);

    const toggleState = ()=>{
        setIsEnabled((prevState) => !prevState);
    }

    const updateTheme = (isDarkEnabled) =>{
        const styles = getComputedStyle(document.body);
        const black = styles.getPropertyValue("--black");
        const white = styles.getPropertyValue("--white"); 

        if(isDarkEnabled){
            document.documentElement.style.setProperty("--background", black);
            document.documentElement.style.setProperty("--foreground", white);
            document.querySelector("html").classList.add("darkmode");
        }else{
            document.documentElement.style.setProperty("--background",white);
            document.documentElement.style.setProperty("--foreground",black);
            document.querySelector("html").classList.remove("darkmode");
        }
    }
 

    
    return (
        <div className="toggle-container">
        <label className="toggle-wrapper" htmlFor="toggle">
            <div className={`toggle ${isEnabled ? "enabled" : "disabled"}`}>
                <span className="hidden"> {isEnabled ? "Enable Light Mode":"Enable Dark Mode"}</span>
                <div className="icons">
                        <FontAwesomeIcon  className="fontsIcons" icon={faSun}/>
                        <FontAwesomeIcon className="fontsIcons" icon={faMoon}/>
              </div>
                <input id="toggle" name="toggle" type="checkbox" checked={isEnabled} onClick={toggleState}/>
            </div>
        </label>
    </div>
    )
}